import { ApplicationExceptionHandler } from '@gtpl/shared-utils/error-messages';
import { Body, Controller, Post, Req } from '@nestjs/common';
import { ApiTags } from '@nestjs/swagger';
import { ItemSubCategoryDto } from './dto/item-sub-category.dto';
import { ItemSubCategoriesService } from './item-sub-categories.service';
import { AllItemSubCategoryResponse, ItemSubCategoriesDropDownResponse, ItemSubCategoryDropDownDto, ItemSubCategoryResponse } from '@gtpl/shared-models/masters';
import { ItemSubCategoryRequest } from './dto/item-sub-category.request';
import { ItemCategoryRequest, ItemsubcategoryforSonumber } from '../item-categories/dto/item-categories.request';
import { CommonResponse } from '@gtpl/shared-models/production-management';
import { UserRequestDto } from '@gtpl/shared-models/common-models';



@Controller('item-sub-categories')
@ApiTags('item-sub-categories')
export class ItemSubCategoriesController {
    constructor(
        private itemCategoryService: ItemSubCategoriesService,
        private readonly applicationExceptionHandler: ApplicationExceptionHandler,
    ){}

      /**
     * creates  a Item SubCategory
     * @param ItemSubCategory Item SubCategory DTO
     * @returns Item SubCategoryResponse
     */
       @Post('/createItemSubCategory')
       async createItemSubCategory(@Body() itemCatDto:ItemSubCategoryDto,isUpdate:boolean=false,@Req() request:Request): Promise<ItemSubCategoryResponse> {
           try {
            return await this.itemCategoryService.createItemSubCategory(itemCatDto,false,request);
          } catch (error) {
               return this.applicationExceptionHandler.returnException(ItemSubCategoryResponse, error);
          }
        }

           /**
     * gets all the Value Item sub Categories
     * @returns AllIte,CategoryResponseModel which returns all the Value Item sub Categories  along with status (true/false), errortype, errorCode, internal message which provides message to the calling function.
     */

    @Post('/getAllItemSubCategories')
    async getAllItemSubCategories(@Body() req?:UserRequestDto): Promise<AllItemSubCategoryResponse> {
        try {
            return await this.itemCategoryService.getAllItemSubCategories(req);
        } catch (error) {
            return this.applicationExceptionHandler.returnException(AllItemSubCategoryResponse, error);
        }
    }

    /**
     *  updates a  value Item Subcategory
     * @param ItemSubCategory ItemSubCategory DTO
     * @returns ItemSubCategoryResponse
     */
     @Post('/updateItemSubCategory')
     async updateItemSubCategory(@Body() itemSubCatDto:ItemSubCategoryDto,isUpdate:boolean=true,@Req() request:Request): Promise<ItemSubCategoryResponse> {
         try {
          return await this.itemCategoryService.createItemSubCategory(itemSubCatDto,true,request);
        } catch (error) {
             return this.applicationExceptionHandler.returnException(ItemSubCategoryResponse, error);
        }
      }

        /**
     *  get all active sub categories 
     * @param ItemCategory ItemSubCategory DTO
     * @returns ItemSubCategoryResponse
     */
    @Post('/getAllItemSubCategoriesDropDown')
    async getAllItemSubCategoriesDropDown(): Promise<ItemSubCategoriesDropDownResponse> {
        try {
         return await this.itemCategoryService.getAllItemSubCategoriesDropDown();
       } catch (error) {
            return this.applicationExceptionHandler.returnException(ItemSubCategoriesDropDownResponse, error);
       }
     }


     @Post('/getItemSubCategoriesForCategoryDropDown')
    async getItemSubCategoriesForCategoryDropDown(@Body() req:ItemCategoryRequest): Promise<ItemSubCategoriesDropDownResponse> {
        try {
         return await this.itemCategoryService.getItemSubCategoriesForCategoryDropDown(req);
       } catch (error) {
            return this.applicationExceptionHandler.returnException(ItemSubCategoriesDropDownResponse, error);
       }
     }

     @Post('/getItemSubCategoryForId')
     async getItemSubCategoryForId(@Body() req:ItemSubCategoryRequest): Promise<ItemSubCategoryDropDownDto> {
         try {
          return await this.itemCategoryService.getItemSubCategoryForId(req.itemSubCategoryId);
        } catch (error) {
             return error;
        }
      }

      @Post('/activateOrDeactivateItemSubCategory')
      async activateOrDeactivateItemSubCategory(@Body()itemReq: ItemSubCategoryRequest): Promise<ItemSubCategoryResponse> {
          try {
           return await this.itemCategoryService.activateOrDeactivateItemSubCategory(itemReq);
         } catch (error) {
              return error;
         }
       }

       @Post('/getitemsubcategoryforsalorderId')
       async getitemsubcategoryforsalorderId(@Body()itemReq: ItemsubcategoryforSonumber): Promise<ItemSubCategoryResponse> {
           try {
            return await this.itemCategoryService.getitemsubcategoryforsalorderId(itemReq);
          } catch (error) {
               return error;
          }
        }

        @Post('/getGeneralItemSubCategories')
        async getGeneralItemSubCategories(): Promise<CommonResponse> {
          try {
           return await this.itemCategoryService.getGeneralItemSubCategories();
         } catch (error) {
              return error;
         }
       }

}
